import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
import { imgSrc } from "../../lib/api";

export const Lightbox = ({ images, index, onClose, onIndex, alt }) => {
  const [zoom, setZoom] = useState(false);
  const [origin, setOrigin] = useState("50% 50%");

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") onIndex((index + 1) % images.length);
      if (e.key === "ArrowLeft") onIndex((index - 1 + images.length) % images.length);
    };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    window.__lenis?.stop();
    return () => { window.removeEventListener("keydown", onKey); document.body.style.overflow = ""; window.__lenis?.start(); };
  }, [index, images.length, onClose, onIndex]);

  useEffect(() => { setZoom(false); }, [index]);

  const move = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    setOrigin(`${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`);
  };

  return (
    <motion.div role="dialog" aria-modal="true" data-testid="stone-lightbox" data-lenis-prevent
      className="fixed inset-0 z-[60] bg-[#121212] text-[#FFFFFF] flex flex-col" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
      <div className="flex items-center justify-between px-6 py-5">
        <span className="f-mono text-xs">{index + 1} / {images.length}</span>
        <button type="button" onClick={onClose} aria-label="Close" data-testid="lightbox-close" className="p-2"><X className="w-6 h-6" strokeWidth={1.25} /></button>
      </div>
      <div className="flex-1 relative overflow-hidden flex items-center justify-center px-4 pb-6"
        onMouseMove={move} onClick={(e) => { move(e); setZoom((z) => !z); }} style={{ cursor: zoom ? "zoom-out" : "zoom-in" }}>
        <img src={imgSrc(images[index])} alt={alt} data-testid="lightbox-image"
          className="max-h-full max-w-full object-contain transition-transform duration-500 ease-out"
          style={{ transform: zoom ? "scale(2.4)" : "scale(1)", transformOrigin: origin }} />
      </div>
      {images.length > 1 && (
        <div className="flex justify-center gap-4 pb-6">
          <button type="button" aria-label="Previous" data-testid="lightbox-prev" className="p-3 border border-[#FFFFFF]/30" onClick={() => onIndex((index - 1 + images.length) % images.length)}><ChevronLeft className="w-5 h-5" strokeWidth={1.25} /></button>
          <button type="button" aria-label="Next" data-testid="lightbox-next" className="p-3 border border-[#FFFFFF]/30" onClick={() => onIndex((index + 1) % images.length)}><ChevronRight className="w-5 h-5" strokeWidth={1.25} /></button>
        </div>
      )}
    </motion.div>
  );
};
